import type { FC, PropsWithChildren } from 'react';

type ErrorFallbackProps = {
	error: unknown;
	eventId: string;
	componentStack: string;
	resetError: () => void;
};

const ErrorFallback: FC<PropsWithChildren<ErrorFallbackProps>> = ({ error, componentStack, resetError, eventId }) => (
	<>
		<div>{'You have encountered an error'}</div>
		<div>{error instanceof Error ? error.toString() : 'An unknown error occurred'}</div>
		<div>{componentStack}</div>
		<button onClick={resetError}>{'Application error, click here to refresh the page'}</button>
		<small>{eventId || ''}</small>
	</>
);

export default ErrorFallback;
